module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_dn-68af89cbb60cf8be050ca64f88916912.gif";